import React from 'react';
import { TextInput, TextInputProps, Input } from '@mantine/core';

type InputProps = TextInputProps & {
  value: string;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  label: string;
  placeholder?: string;
  required?: boolean;
};

export default function FloatingLabelInput(props: InputProps) {
  const { label, placeholder, required, value, onChange, disabled, ...restProps } = props;

  return (
    <Input.Wrapper withAsterisk={required} label={label} {...restProps}>
      <TextInput
        placeholder={placeholder}
        required={required}
        disabled={disabled}
        value={value}
        onChange={onChange}
        autoComplete="nope"
      />
    </Input.Wrapper>
  );
}
